import styled from "styled-components";

export const DealerAvatarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
